/**
 * 判断当前环境是否为微信环境
 * @returns {boolean} 如果是微信环境返回 true，否则返回 false
 * @example
 * ```ts
 * isInWeixin(); // => true (在微信内)
 * isInWeixin(); // => false (在浏览器中)
 * ```
 */
export function isInWeixin(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent.toLowerCase();
  return /\bmicromessenger\b/i.test(ua);
}
